import {HighlightedWinningSliceContainerBox} from "./boxes/highlighted-winning-slice/highlighted-winning-slice-container.box";
import {HighlightedWinningSliceWrapperBox} from "./boxes/highlighted-winning-slice/highlighted-winning-slice-wrapper.box";
import {SliceFillBox} from "./boxes/highlighted-winning-slice/slice-fill/slice-fill.box";
import {SliceLineBox} from "./boxes/highlighted-winning-slice/slice-line.box";

interface IHighlightedWinningSliceProps {
    degrees: number;
    numberOfSlices: number;
    isWinningAnimationFired: boolean;
    onWheelRotationEnd?(): void;
}

export const HighlightedWinningSlice: React.FC<IHighlightedWinningSliceProps> = ({degrees, numberOfSlices, isWinningAnimationFired, onWheelRotationEnd}) => {
    return <HighlightedWinningSliceContainerBox
        className={'slices-container ' + (isWinningAnimationFired ? 'animate' : '')}
        style={{transform: `rotate(-${degrees}deg)`}}
    >
        <HighlightedWinningSliceWrapperBox className="slice-wrapper">
            <SliceFillBox className="circle-slice" animate={isWinningAnimationFired} enlarge={false} numberOfSlices={numberOfSlices}>
                <svg viewBox="0 0 64 64">
                    <circle r="32" cx="32" cy="32"></circle>
                </svg>
            </SliceFillBox>
            <SliceLineBox className="slice-line first" animate={isWinningAnimationFired} numberOfSlices={numberOfSlices} ></SliceLineBox>
            <SliceLineBox className="slice-line second" animate={isWinningAnimationFired} numberOfSlices={numberOfSlices} secondLine={true}></SliceLineBox>
            <SliceFillBox className="circle-slice" animate={isWinningAnimationFired} enlarge={true} numberOfSlices={numberOfSlices} onAnimationEnd={event => {
                // The enlarging slice is the last animation so we can safely call onWheelRotationEnt
                if (onWheelRotationEnd) {
                    onWheelRotationEnd();
                }
            }}>
                <svg viewBox="0 0 64 64">
                    <circle r="32" cx="32" cy="32"></circle>
                </svg>
            </SliceFillBox>
        </HighlightedWinningSliceWrapperBox>
    </HighlightedWinningSliceContainerBox>
}